import React from 'react';
import { Dialog } from './ds/feedback/Dialog';

/**
 * YapperModal - in-app replacement for browser alert()/confirm() dialogs.
 * Thin wrapper around the design-system Dialog so every caller gets the
 * white card + emoji-by-type + ghost/primary-danger button styling.
 *
 * Alert (single button): pass isOpen, title, message, onConfirm.
 * Confirm (two buttons): also pass onCancel (and optional confirmText/cancelText).
 */
const YapperModal = ({
  isOpen,
  title = 'Yapp',
  message,
  onConfirm,
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  type = 'info',
}) => {
  return (
    <Dialog
      open={isOpen}
      title={title}
      message={message}
      type={type}
      confirmText={confirmText}
      cancelText={cancelText}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default YapperModal;
